import { __rest } from "tslib";
import React from 'react';
import { PrintOnlyImageSource } from './printOnlySource';
class ImageRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.imageRef = null;
    }
    componentDidMount() {
        var _a;
        if (((_a = this.imageRef) === null || _a === void 0 ? void 0 : _a.complete) && typeof this.props.onLoad === 'function') {
            this.props.onLoad();
        }
    }
    render() {
        const _a = this.props, { customImageRenderer } = _a, imageProps = __rest(_a, ["customImageRenderer"]); // customImageRenderer is not valid for dom elements.
        if (typeof customImageRenderer === 'function') {
            return customImageRenderer(this.props);
        }
        else if (typeof this.props.src === 'string') {
            return (React.createElement("img", Object.assign({ ref: (ref) => {
                    this.imageRef = ref;
                }, alt: this.props.alt }, imageProps)));
        }
        else if (typeof this.props.src === 'object') {
            return (React.createElement("picture", { id: `multi_picture_${this.props.id}`, key: `multi_picture_${this.props.id}` },
                this.props.src.map((src, index) => src.forPrinting ? (React.createElement(PrintOnlyImageSource, { key: `print-only-image-${index}`, srcSet: src.dpr, type: `image/${src.type}` })) : (React.createElement("source", { key: `image-source-${index}`, srcSet: src.dpr || src.url, type: `image/${src.type}` }))),
                React.createElement("img", Object.assign({ ref: (ref) => {
                        this.imageRef = ref;
                    }, alt: this.props.alt }, imageProps, { src: this.props.src[this.props.src.length - 1].url }))));
        }
        else {
            return null;
        }
    }
}
export default ImageRenderer;
//# sourceMappingURL=imageRenderer.js.map